import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {ZzFlatButtonRoute} from "core/components/buttons/buttons";
import {MODULE, PERMISSION, PageProps} from "core/metamodel/metaConstant";
import {PAGE} from "routes";
import mdEntityService from "core/metamodel/mdEntityService";
import {observer} from "mobx-react";
import {loc} from "core/common/config/locales";

const gridLocation = 'eventTypeList';

@observer
export default class EventTypeList extends  PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = loc.i18n`Event Types`;
  static icon = 'send';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("EventTypeList#fetchData(%s)", gridLocation);
    return gridService.fetchGrids(gridLocation)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(gridLocation)
    });

  }


  render() {
    let {params, query} = this.props;

    return (
        <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query}>
          <ZzFlatButtonRoute onGridToolbar routeName="eventTypeDetail" params={{id: 'new'}} label="New Event Type" permission={PERMISSION.New} securable={PAGE.eventTypeDetail}/>
        </GridCompConnected>
    );
  }

}



// WEBPACK FOOTER //
// ./src/core/event/eventTypeList.tsx